import { render, staticRenderFns } from "./reportsPage.html?vue&type=template&id=70978b49&"
import script from "./reportsPage.vue?vue&type=script&lang=js&"
export * from "./reportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports